import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import EvaluatorPaymentService from '../../../../Services/EvaluatorPaymentService';
import EvaluatorPaymentActionParamsItem from './EvaluatorPaymentActionParamsItem';

export default class ApproveWindowDescription {
  static titleForCreate = 'Approve';
  static titleForEdit = 'Approve';
  static finishButtonLabel = 'Approve';
  static itemType = EvaluatorPaymentActionParamsItem;
  static serviceFunction = (edited) => EvaluatorPaymentService.Approve(edited);
  static waitForServiceFunction = () => false;
  static messageOnSuccess =
    'The Approve process has been started. You will receive a notification about the result in your personal notification repository.';

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [{ fieldName: 'Reason', label: 'Comment', className: 'col-12', type: InputTypesEnum.TextBox }],
    },
  ];
}
